<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <add-to-calendar-button
    options="'Apple', 'Google', 'iCal', 'Outlook.com', 'MicrosoftTeams', 'Yahoo'"
    timeZone="Europe/Athens"
    hideCheckmark="true"
    trigger="click"
    label="Προσθήκη σε Ημερολόγιο"
    :size="size"
    :name="congress.title"
    :description="(congress.description || '').replace(/<[^>]*>/g, '')"
    :location="congress.location"
    :startDate="shortDateIso(congress.startDate)"
    :endDate="shortDateIso(congress.endDate)"
    :startTime="shortTime(congress.startDate)"
    :endTime="shortTime(congress.endDate)"
    :hideTextLabelButton="hideLabel"
  />
</template>
<script>
import 'add-to-calendar-button'
import 'add-to-calendar-button/assets/css/atcb.css'
export default {
  props: {
    congress: {
      type: Object,
      required: true
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "3"
    }
  }
}
</script>